export default {
  version: "",
  text: "",
};
